<!--HVPG测定（可选）-->
<script setup>
import { computed, reactive, watch,ref,watchEffect } from "vue";
import { useCrfStore } from "@/stores/crf";
import upload from "@/components/upload1.vue"
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

const onChange = {
  "HVPG测定": (newValue) => {
    if (newValue === "未测") {
      ["HVPG测定：指标（mmHg）"].forEach((key) => {
        model.fields[props.type][key] = [];
      });
    }
  }
};

const isVisible = computed(() => {
  let result = {};
  ["HVPG测定"].forEach((field) => {
    result[field] = model.fields[props.type][field] === "已测";
  });
  return result;
});

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

watchEffect(()=>{
  // model.fields[`${props?.type}`]?.['肝静脉压力梯度（WVPG）'] = model.fields[`${props.type}`]?.['肝静脉楔入压（WHVP）']  - model.fields[`${props.type}`]?.['肝静脉游离压（FHVP）']
})




// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display: flex; align-items: center;">
      <h2>HVPG测定（可选）</h2>
      <check :period="props.type" text="HVPG测定（可选）" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="HVPG测定是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['HVPG测定是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['HVPG测定是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增HVPG测定':'HVPG测定'"  class="not_redStar">
          <el-radio-group v-model="crfFields['HVPG测定']" @change="onChange['HVPG测定']">
            <el-radio label="已测" prop="已测"></el-radio>
            <el-radio label="未测" prop="未测"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="isVisible['HVPG测定']" label="指标（mmHg）" :prop="itemProp('HVPG测定：指标（mmHg）')"
                      :rules="crfStore.textRules('指标',true)">
          <el-input v-model="crfFields['HVPG测定：指标（mmHg）']" placeholder="请输入指标" autocomplete="off">
            <template #append>mmHg</template>
          </el-input>
        </el-form-item>
        <!-- 肝静脉楔入压（WHVP）：
            肝静脉游离压（FHVP）：
            肝静脉压力梯度（WVPG）：
            肝静脉楔入压-肝静脉游离压=肝静脉压力梯度 -->
        <el-form-item v-if="isVisible['HVPG测定']" label="肝静脉楔入压（WHVP）" 
          :prop="itemProp('肝静脉楔入压（WHVP）')" :rules="crfStore.textRules('肝静脉楔入压',true)">
          <el-input v-model="crfFields['肝静脉楔入压（WHVP）']" placeholder="请输入指标" autocomplete="off">
            <template #append>mmHg</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="isVisible['HVPG测定']" label="肝静脉游离压（FHVP）" 
            :prop="itemProp('肝静脉游离压（FHVP）')" :rules="crfStore.textRules('肝静脉游离压',true)">
          <el-input v-model="crfFields['肝静脉游离压（FHVP）']" placeholder="请输入指标" autocomplete="off">
            <template #append>mmHg</template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="isVisible['HVPG测定']" label="肝静脉压力梯度（WVPG）" 
          :prop="itemProp('HVPG测定：指标（mmHg）')" >
          <el-input v-model="crfFields['肝静脉压力梯度（WVPG）']" placeholder="请输入指标" autocomplete="off">
            <template #append>mmHg</template>
          </el-input>
        </el-form-item>

        <upload v-if="crfFields['HVPG测定'] == '已测'" :type="props.type" :data="model" name="hvpgcd"></upload>
      </template>
  </template>
</template>

<style scoped>
</style>